import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { LogForm } from 'components/forms'
import { form } from 'helpers/decorators'
import validate from './add-log.validation'

@form({
  form: 'addLog',
  disableHook: true,
  validate
})
class AddLog extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    onAddLog: PropTypes.func,
    reset: PropTypes.func,
    activityId: PropTypes.string,
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    submitDisabled: PropTypes.bool,
    submitting: PropTypes.bool
  }

  handleSubmit = data =>
    this.props.onAddLog(data, this.props.activityId, {
      resetForm: this.props.reset
    })

  render() {
    const {
      reset,
      modalId,
      colorClass,
      handleSubmit,
      submitDisabled,
      submitting
    } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title="Add Log"
        titleKey="moduleTitle.add_log"
        colorClass={colorClass}
        onClose={reset}
        onSubmit={handleSubmit(this.handleSubmit)}
        noEscape
      >
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <MaterialModal.Content>
            <LogForm />
          </MaterialModal.Content>

          <MaterialModal.Footer
            action="Add Log"
            actionKey="button.add_log"
            isLoading={submitting}
            colorClass={colorClass}
            disabled={submitDisabled || submitting}
            dataTestId="submitAddLogButtonSelector"
          />
        </form>
      </MaterialModal.Body>
    )
  }
}

export default AddLog
